import { Stack, Typography } from '@mui/material';

import { Callout } from '@/components/notifications/Callout/Callout';
import { useIsHouseholdWorkflowTrackerInProgress } from '@/modules/workflowTrackers/hooks/useIsHouseholdWorkflowTrackerInProgress';
import { WorkflowTrackerKind } from '@/types/schema';

/** Shows a banner while a memo generation for the household is in progress. */
export function MemoGeneratingCallout() {
  const isMemoGenerating = useIsHouseholdWorkflowTrackerInProgress(
    WorkflowTrackerKind.MemoGeneration
  );
  if (!isMemoGenerating) return null;

  return (
    <Stack>
      <Callout severity="success">
        <Typography variant="title-xs" paddingBottom={0.5}>
          Generating memo
        </Typography>

        <Typography variant="body-xs">
          Your memo is being generated and will appear in the table below when
          ready.
        </Typography>
      </Callout>
    </Stack>
  );
}
